import { useState } from "react";
import React from "react";
import { TimeCellWrapper } from "../StyledComponents";
import useCalendar from "../../../context/useCalendar";
import { useSelector } from "../../../../store/store";
import {
    getReservationsInSlot,
    getRestrictedReservationsInSlot,
} from "../../../../store/data";
import { format } from "date-fns";
import ReservationModal from "../../../../modal/ReservationModals/ReservationModal";

interface Props {
    template?: boolean;
    time: Date;
    isConsultation: boolean;
}

const TimeCell = ({ time, template = false, isConsultation }: Props) => {
    const [isOpen, setOpen] = useState(false);
    const {
        calendarSettings: { intervalLength },
    } = useCalendar();

    const reservations = useSelector(
        getReservationsInSlot(time, intervalLength)
    );

    const restrictedReservations = useSelector(
        getRestrictedReservationsInSlot(time, intervalLength)
    );

    const hasReservation =
        reservations.length > 0 || restrictedReservations.length > 0;

    const handleClick = () => {
        if (!hasReservation) {
            return;
        }

        setOpen(true);
    };

    return (
        <>
            <TimeCellWrapper
                isConsultation={isConsultation}
                isReservation={hasReservation && !template}
                onClick={handleClick}
            >
                {template && format(time, "HH:mm")}
            </TimeCellWrapper>
            {isOpen && (
                <ReservationModal
                    reservations={reservations}
                    restrictedReservations={restrictedReservations}
                    open={isOpen}
                    onClose={() => setOpen(false)}
                />
            )}
        </>
    );
};

export default React.memo(TimeCell);
